module.exports = {
  siteTitle: "Le Relais de l'Avance Restaurant Traiteur Mariage Hautes Alpes", // <title>
  manifestName: 'Casual',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.jpg',
  pathPrefix: `/gatsby-starter-casual/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Relais de l’avance traiteur mariage Hautes Alpes',
  subHeading: 'A Free Bootstrap 4 based Gatsby Starter',
};
